import { Obj } from '.';
export class Func {
/**
 * Returns whether the given argument is not a function
 * @param {?} arg
 * @return {?}
 */
public static isNotAFunction(arg: any): boolean {
    return Obj.isNullOrUndefined(arg) || typeof arg !== 'function';
  }
/**
 * Returns whether the given argument is a function
 * @param {?} arg
 * @return {?}
 */
public static isAFunction(arg: any): boolean {
    return !Func.isNotAFunction(arg);
  }
}